'use strict';
namespace TR {

    class PromotionTermsPageConfig {
        imgUrl: string;
        subTitle1: string;
        subTitle2: string;
        title: string;
        titleText: string;
    }

    class PromotionTerm {
        Name: string;
        Text: string;
    }

    class PromotionTerms {
        word: string;
        promotionTermsPageConfig: PromotionTermsPageConfig;
        isLoading: boolean;
        promotionsTermsList: PromotionTerm[];

        constructor(
            private hotelSearch: any
        ) {
            this.promotionTermsPageConfig = TRPCONFIG.Domain.PromotionTermsPageConfig;
            this.hotelSearch.getPromotionTerms().then(res => {
                this.promotionsTermsList = res;
            })
            .catch(function () { return false; });
        }
    }

    angular
        .module('TR')
        .controller('PromotionTerms', PromotionTerms);
}
